export const LINK_CODES = {
    SCHEDULE_DEMO_WITH_LIVE_DATA: 'schedule_a_demo_with_live_data',
    ACV_ARTICLE: 'acv_article',
    NIQ_DATA_SHARING_GUIDELINES: 'niq_data_sharing_guidelines',
} as const;

export const PAGE_CODES = {
    FREE_HOME: 'free_homepage',
    DOD_FACTS_STEP: 'dod_facts_step',
    MY_REPORTS: 'my_reports',
    HELP_MENU: 'help_menu',
} as const;
